import { PanelSectionHeader } from "./PanelSectionHeader";
import type { PanelSectionProps } from "./types";

export const PanelSection = ({
  tone,
  title,
  count,
  action,
  isOpen,
  onToggle,
  children,
  onHoverIn,
  onHoverOut,
  testId,
}: PanelSectionProps) => (
  <div
    data-testid={testId}
    onMouseEnter={onHoverIn}
    onMouseLeave={onHoverOut}
    className="overflow-hidden rounded-lg border border-slate-200 bg-white"
  >
    <PanelSectionHeader
      tone={tone}
      title={title}
      count={count}
      action={action}
      isOpen={isOpen}
      onToggle={onToggle}
    />
    {/* Bounded here, for every section, and capped against the VIEWPORT as
        well as a height: an open section used to be able to take the whole
        column and push the runs it qualifies past the fold. */}
    {isOpen && (
      <div
        data-testid={testId ? `${testId}-body` : undefined}
        className="max-h-[min(22rem,30vh)] overflow-y-auto border-t border-slate-200 p-2"
      >
        {children}
      </div>
    )}
  </div>
);
